export function mouseOverCircle(x: number, y: number, radius: number): (mx: number, my: number) => boolean {
  return (mx, my) => {
    const dx = mx - x;
    const dy = my - y;
    return dx * dx + dy * dy <= radius * radius;
  }
}
